import type { AreaCatalog } from '../area';
import type { shell as en } from '../en/shell';

export const shell = {
  'shell.brand.name': 'Tesserano',
  'shell.brand.home': 'Tesserano-Startseite',
  'shell.brand.description':
    'Ein Röntgenbild für Organisationen: der Graph, wer was von wem braucht.',
  'shell.page.activity': 'Aktivität',
  'shell.page.work': 'Aufgaben',
  'shell.page.map': 'Landkarte',
  'shell.page.tags': 'Tags',
  'shell.page.groups': 'Gruppen',
  'shell.page.flowPhases': 'Ablaufphasen',
  'shell.page.flows': 'Abläufe',
  'shell.page.plans': 'Pläne',
  'shell.page.ceremonies': 'Besprechungen',
  'shell.page.search': 'Suche',
  'shell.page.views': 'Boards',
  'shell.page.lenses': 'Ansichten',
  'shell.page.account': 'Konto',
  'shell.page.contacts': 'Kontakte',
  'shell.page.admin': 'Admin',
  'shell.page.design': 'Design',
  'shell.section.activity': 'Verlauf',
  'shell.section.relationships': 'Beziehungen',
  'shell.section.proposed': 'Änderungsvorschläge',
  'shell.section.description': 'Beschreibung',
  'shell.section.files': 'Dateien',
  'shell.section.details': 'Details',
  'shell.nav.primary': 'Hauptnavigation',
  'shell.nav.unread': { one: '{count} ungelesen', other: '{count} ungelesen' },
  'shell.nav.pinned': 'Angeheftet',
  'shell.nav.allLenses': 'Alle Ansichten',
  'shell.nav.allViews': 'Alle Boards',
  'shell.nav.newLens': 'Neue Ansicht',
  'shell.nav.newView': 'Neues Board',
  'shell.nav.newTask': 'Neue Aufgabe',
  'shell.nav.showMore': { one: '{count} weitere anzeigen', other: '{count} weitere anzeigen' },
  'shell.nav.showLess': 'Weniger anzeigen',
  'shell.nav.sortLenses': 'Ansichten sortieren',
  'shell.nav.sortViews': 'Boards sortieren',
  'shell.nav.sortLensesBy': 'Ansichten sortieren ({sort})',
  'shell.nav.sortViewsBy': 'Boards sortieren ({sort})',
  'shell.nav.sortBy': 'Sortieren nach',
  'shell.viewsSort.viewed': 'Zuletzt angesehen',
  'shell.viewsSort.recent': 'Zuletzt hinzugefügt',
  'shell.viewsSort.changed': 'Zuletzt geändert',
  'shell.viewsSort.type': 'Nach Art',
  'shell.viewsSort.alpha': 'Alphabetisch',
  'shell.sidebar.expand': 'Seitenleiste ausklappen',
  'shell.sidebar.collapse': 'Seitenleiste einklappen',
  'shell.sidebar.expandShort': 'Ausklappen',
  'shell.sidebar.collapseShort': 'Einklappen',
  'shell.topbar.search': 'Suchen (Strg+O)',
  'shell.newItem.title': 'Neue Aufgabe',
  'shell.profile.menu': 'Profilmenü',
  'shell.profile.sheet': 'Profil',
  'shell.profile.appearance': 'Erscheinungsbild',
  'shell.profile.signOut': 'Abmelden',
  'shell.profile.signInAs': 'Persona',
  'shell.profile.testing': 'Test',
  'shell.profile.handle': '@{handle}',
  'shell.theme.light': 'Hell',
  'shell.theme.auto': 'Auto',
  'shell.theme.dark': 'Dunkel',
  'shell.elevate.until': 'Eingriffsmodus · bis {time}',
  'shell.elevate.end': 'Beenden',
  'shell.queue.full':
    'Zu viele Änderungen warten auf den Abgleich. Stell erst wieder eine Verbindung her, bevor du weiterarbeitest.',
  'shell.queue.offline': 'Offline vorgenommene Änderungen warten auf eine Verbindung.',
  'shell.queue.waiting': { one: 'wartet', other: 'warten' },
  'shell.trail.label': 'Pfad',
  'shell.trail.back': 'Zurück',
  'shell.trail.backOneStep': 'Einen Schritt zurück',
  'shell.trail.hiddenSteps': 'Ausgeblendete Schritte',
  'shell.trail.showHidden': 'Ausgeblendete Schritte anzeigen',
  'shell.trail.more': { one: '{count} weiterer', other: '{count} weitere' },
  'shell.loading.label': 'Wird geladen',
  'shell.loading.back': 'Zurück',
  'shell.loading.aboutItem': 'Über diese Aufgabe',
  'shell.loading.nextStep': 'Nächster Schritt',
  'shell.skeleton.titleColumn': 'Titel',
  'shell.skeleton.activityDetail': 'Öffne einen Eintrag, um hier seine Details zu lesen.',
  'shell.loadError.title': 'Nicht geladen',
  'shell.loadError.offlineItem': 'Offline. Diese Aufgabe wurde nicht geladen.',
  'shell.loadError.offlinePage': 'Offline. Diese Seite wurde nicht geladen.',
  'shell.loadError.item': 'Diese Aufgabe konnte nicht geladen werden.',
  'shell.loadError.page': 'Diese Seite konnte nicht geladen werden.',
  'shell.loadError.retry': 'Erneut versuchen',
  'shell.loadError.back': 'Zurück',
  'shell.queue.refused': 'Diese Änderung wurde abgelehnt.',
  'shell.trail.root.work': 'Aufgaben',
  'shell.trail.root.search': 'Suche',
} as const satisfies AreaCatalog<typeof en>;
